import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conflict-checker"
// Updates the hidden button's formAction with the selected unit ID, then clicks it.
export default class extends Controller {
  static targets = ["unit", "button"]
  static values = { urlTemplate: String }

  check() {
    const unitId = this.unitTarget.value
    if (!unitId) return

    this.buttonTarget.formAction = this.urlTemplateValue.replace("UNIT_PLACEHOLDER", unitId)
    this.buttonTarget.click()
  }
}
